import { LifeSkillsMonitoringStage } from 'api';

export const getLifeSkillsMonitoringStageName = (stageType: LifeSkillsMonitoringStage): string => {
  const stageTypeNames: Record<LifeSkillsMonitoringStage, string> = {
    [LifeSkillsMonitoringStage.First]: 'First',
    [LifeSkillsMonitoringStage.Second]: 'Second',
    [LifeSkillsMonitoringStage.Third]: 'Third',
    [LifeSkillsMonitoringStage.Fourth]: 'Fourth',
  };
  return stageTypeNames[stageType] ?? '-';
};
